import React, { useState } from "react";
import NativeSelect from "@material-ui/core/NativeSelect";
import CompareTableStyles, {
  PRIMARY_COLLUMN_CLASS,
  COMPETING_COLUMNS_CLASS,
  DYNAMIC_COLUMN_CLASS,
  CELL_DIVIDER_CLASS,
  HIGHLIGHT_CLASS
} from "./CompareTableStyles";

const useStyles = CompareTableStyles();

function CompareTable({ table, disclaimer_processor }) {
  const [selectedComparison, setSelectedComparison] = useState(1);
  const classes = useStyles();

  //Occupies the top left cell
  const EMPTY_CELL = <th></th>;

  //All collumns except the primary
  const COMPETING_PRODUCT_HEADERS = table.headers?.slice(1);
  return (
    <div className={classes.wrapper}>
      <table className={classes.root}>
        {/* Headings / Top Row */}
        <thead className={classes.header}>
          <tr>
            {/* Empty Cell */}
            {EMPTY_CELL}
            {/* Collumn Titles */}
            {table?.headers?.map((header, header_idx) => (
              <th
                className={
                  header_idx === 0
                    ? PRIMARY_COLLUMN_CLASS
                    : COMPETING_COLUMNS_CLASS
                }
                key={header_idx}
              >
                {header}
              </th>
            ))}
            {/* Dropdown Menu */}
            <th className={DYNAMIC_COLUMN_CLASS}>
              <NativeSelect
                value={selectedComparison}
                onChange={(e) => setSelectedComparison(e.currentTarget.value)}
              >
                {COMPETING_PRODUCT_HEADERS?.map(
                  (header_content, header_idx) => {
                    const INDEXOF_SELECTED_PRODUCT = header_idx + 1;
                    return (
                      <option key={header_idx} value={INDEXOF_SELECTED_PRODUCT}>
                        {header_content}
                      </option>
                    );
                  }
                )}
              </NativeSelect>
            </th>
          </tr>
        </thead>
        {/* Rows / Body Rows */}
        <tbody className={classes.body}>
          {table?.rows?.map((row, row_idx) => {
            const SHOW_DIVIDER = row_idx < table.rows.length - 1;
            const disclaimers_list = [
              [row.header_disclaimer || []].flat(),
              ...row.extra_header_disclaimers
            ].flat();
            const HEADER_DISCLAIMER = disclaimers_list
              .map((d) => disclaimer_processor?.processDisclaimer?.(d))
              .join("");
            const HEADER_CONTENT = `${row.header}${HEADER_DISCLAIMER}`;
            let compared_value_raw = row?.values[selectedComparison] || [];
            if (!Array.isArray(compared_value_raw)) {
              compared_value_raw = [compared_value_raw];
            }
            const compared_value = compared_value_raw
              .map(({ value }) => value)
              .join("");
            return (
              <React.Fragment key={row_idx}>
                <tr>
                  <th>
                    {/* The Row Titles */}
                    <div
                      className="header"
                      dangerouslySetInnerHTML={{ __html: HEADER_CONTENT }}
                    />
                  </th>
                  {row.values.map((value_data = [], value_idx) => {
                    let { value, disclaimer, highlight } = value_data;
                    let HIGHLIGHT = highlight ? HIGHLIGHT_CLASS : "";
                    return (
                      <td
                        className={
                          value_idx === 0
                            ? PRIMARY_COLLUMN_CLASS
                            : COMPETING_COLUMNS_CLASS
                        }
                        key={value_idx}
                      >
                        <div className={"cell-container"}>
                          <span
                            className={HIGHLIGHT}
                            dangerouslySetInnerHTML={{ __html: value }}
                          />
                          {disclaimer && (
                            <span
                              className={HIGHLIGHT}
                              dangerouslySetInnerHTML={{
                                __html:
                                  disclaimer_processor?.processDisclaimer?.(
                                    disclaimer
                                  )
                              }}
                            />
                          )}
                        </div>
                      </td>
                    );
                  })}
                  <td
                    className={DYNAMIC_COLUMN_CLASS}
                    dangerouslySetInnerHTML={{
                      __html: compared_value
                    }}
                  />
                </tr>
                {SHOW_DIVIDER && (
                  <tr className="divider-row">
                    {[0, ...row.values].map((value_data, value_idx) => (
                      <React.Fragment key={value_idx}>
                        {value_idx === 0 && <th />}
                        {value_idx === 1 && (
                          <td className={PRIMARY_COLLUMN_CLASS}>
                            <span className={CELL_DIVIDER_CLASS} />
                          </td>
                        )}
                        {value_idx > 1 && value_idx <= 4 && (
                          <td className={COMPETING_COLUMNS_CLASS}>
                            <span className={CELL_DIVIDER_CLASS} />
                          </td>
                        )}
                      </React.Fragment>
                    ))}
                    <td className={DYNAMIC_COLUMN_CLASS}>
                      <span className={CELL_DIVIDER_CLASS} />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CompareTable;
